import React, { Component } from 'react';
import { Row, Col, Input, Form, Icon } from 'antd';
import Captcha from './Captcha';

export default class CaptchaForm extends Component {
    state = { captchaFormProps: {
        validated: false,
        hasFeedback: true,
        help: '',
        validateStatus: '',
        required: true,
        label: 'Please enter the following characters to proceed',
        field: ''
    }}

    constructor(props) { 
        super(props); 
        const { services } = this.props;        
        this.updateCaptchaField = this.updateCaptchaField.bind(this);
        this.resetField = this.resetField.bind(this);
    }

    componentWillMount(){
        const
        { services } = this.props;
    }
    
    //isDisabled = () => this.props.state.field.length === 8 ? true : false;
    isDisabled = () => this.state.captchaFormProps.field.length === 8 ? true : false;

    resetField(){
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:''} }
            })
    }

    updateCaptchaField(e){
        const
        { services } = this.props,
        value = e.target.value;

        if(this.state.captchaFormProps.field.length !== 8 && value.length === 8){
            services.validateCaptcha(value);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value} }
           })
    }

    setFormProps = prev => {
        const
        pStatus = prev.state.validation.status,
        cStatus = this.props.state.validation.status;

        if(pStatus === null && cStatus === 'pending') {
            this.setState ((state, props) => { return {...state, captchaFormProps: {...state.captchaFormProps,
                help: 'Validating...',
                validateStatus: 'validating'
            }}
        })
        } else if(pStatus === 'pending' && cStatus === 'success') {
            this.setState ((state, props) => { return {...state, captchaFormProps: {...state.captchaFormProps,
                help: 'Validation successful',
                validateStatus: 'success'
            }}
        })
        } else if(pStatus === 'pending' && cStatus === 'failure') {
            this.setState ((state, props) => { return {...state, captchaFormProps: {...state.captchaFormProps,
                help: 'Unable to validate',
                validateStatus: 'error'
            }}
        })
        }else if(pStatus != null && pStatus.length > 0 && cStatus === null) {
            this.setState ((state, props) => { return {...state, captchaFormProps: {...state.captchaFormProps,
                help: '',
                validateStatus: ''
            }}
        })
        }
    }
    componentDidUpdate(prev) {
         this.setFormProps(prev);                  
    }

    render() {
        const
        { services, state, disabled } = this.props,
        { request, validation } = state,
        { captchaFormProps } = this.state;
        return (
            <div>
                <Form.Item {...captchaFormProps} style={{ width: '241px' }}>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <Captcha services={services} state={state} resetField={this.resetField}/>
                        </Col>
                    </Row>
                    <Input
                        size='small'
                        placeholder='Verification code'
                        prefix={<Icon type='lock' style={{ color: 'rgba(0, 0, 0, .50)' }} />}
                        onChange={this.updateCaptchaField}
                        value={this.state.captchaFormProps.field}
                        disabled={this.isDisabled()}
                        style={{ width: '241px' }}
                    />
                </Form.Item>
            </div>
        )
    }
}
